import { restmethod } from '../../../httpsnippet-lite/targets/powershell/restmethod/client.js';
import { convertWithHttpSnippetLite } from '../../../utils/convertWithHttpSnippetLite.js';
/**
 * powershell/restmethod
 */
export const powershellRestmethod = {
    target: 'powershell',
    client: 'restmethod',
    title: 'Invoke-RestMethod',
    generate(request) {
        // TODO: Write an own converter
        return convertWithHttpSnippetLite(restmethod, request);
    },
};
